// eslint-disable-next-line no-shadow
export var IPublicTypeLocationDetailType = /*#__PURE__*/function (IPublicTypeLocationDetailType) {
  IPublicTypeLocationDetailType["Children"] = "Children";
  IPublicTypeLocationDetailType["Prop"] = "Prop";
  return IPublicTypeLocationDetailType;
}({});

/**
 * @deprecated please use IPublicTypeLocationDetailType
 */
export var LocationDetailType = /*#__PURE__*/function (LocationDetailType) {
  LocationDetailType["Children"] = "Children";
  LocationDetailType["Prop"] = "Prop";
  return LocationDetailType;
}({});